import type { CSSProperties, MouseEvent } from "react";
import { Dropdown } from "@v0y4ge/jrni-ui";

/** Hover styles for ported `style-hover` rules: applied on enter, restored on leave. */
export function hov(over: CSSProperties) {
  return {
    onMouseEnter: (e: MouseEvent<HTMLElement>) => {
      const el = e.currentTarget as HTMLElement & { __hovPrev?: Record<string, string> };
      const prev: Record<string, string> = {};
      Object.entries(over).forEach(([k, val]) => { prev[k] = (el.style as unknown as Record<string, string>)[k]; (el.style as unknown as Record<string, string>)[k] = String(val); });
      el.__hovPrev = prev;
    },
    onMouseLeave: (e: MouseEvent<HTMLElement>) => {
      const el = e.currentTarget as HTMLElement & { __hovPrev?: Record<string, string> };
      Object.entries(el.__hovPrev || {}).forEach(([k, val]) => { (el.style as unknown as Record<string, string>)[k] = val; });
    },
  };
}

export interface OptRow { label?: string; title?: string; when?: string; on?: boolean | string; onPick?: () => void }

/** The ported option lists ({label, on, onPick}) rendered through the jrni-ui Dropdown, in a portal so it never clips. */
export function OptDropdown({ opts, disabled, ariaLabel, style }: { opts: OptRow[] | undefined; disabled?: boolean; ariaLabel?: string; style?: CSSProperties }) {
  const list = opts || [];
  const cur = list.findIndex((o) => o.on === true || o.on === "true");
  return (
    <Dropdown
      size="sm"
      portal
      disabled={!!disabled}
      aria-label={ariaLabel}
      style={style}
      value={cur >= 0 ? String(cur) : null}
      options={list.map((o, i) => ({ value: String(i), label: o.label ?? o.title ?? "", supportingText: o.when }))}
      onChange={(val: string) => { const o = list[Number(val)]; if (o && o.onPick) o.onPick(); }}
    />
  );
}
